import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Inbox, AlertCircle, SearchX, RefreshCw } from "lucide-react";

export function EmptyState({ icon: Icon = Inbox, title, description, action, onAction, className, testId }) {
  return (
    <div data-testid={testId} className={cn("flex flex-col items-center justify-center rounded-2xl border border-dashed border-border/70 bg-card/30 px-6 py-16 text-center", className)}>
      <div className="mb-4 rounded-2xl border border-border/60 bg-secondary/40 p-3.5 text-muted-foreground">
        <Icon className="h-6 w-6" />
      </div>
      <h3 className="font-display text-base font-medium text-foreground">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && (
        <Button variant="secondary" size="sm" className="mt-5" onClick={onAction} data-testid="empty-state-action">
          {action}
        </Button>
      )}
    </div>
  );
}

export function ErrorState({ onRetry, message = "Unable to load fleet data", className }) {
  return (
    <div className={cn("flex flex-col items-center justify-center rounded-2xl border border-red-500/20 bg-red-500/5 px-6 py-16 text-center", className)}>
      <div className="mb-4 rounded-2xl border border-red-500/30 bg-red-500/10 p-3.5 text-red-400">
        <AlertCircle className="h-6 w-6" />
      </div>
      <h3 className="font-display text-base font-medium text-foreground">{message}</h3>
      <p className="mt-1 text-sm text-muted-foreground">Something went wrong while contacting the fleet service.</p>
      {onRetry && (
        <Button variant="secondary" size="sm" className="mt-5" onClick={onRetry}>
          <RefreshCw className="mr-2 h-3.5 w-3.5" /> Retry
        </Button>
      )}
    </div>
  );
}

export function NoResults({ title = "No results found", description = "Try adjusting your filters or search terms." }) {
  return <EmptyState icon={SearchX} title={title} description={description} />;
}
